import Block from "../Block";
import "./BlockStatement.css";
import BlockChild from "../BlockChild/BlockChild";
import imageStatementPreview from "/src/features/editor/image/propos_preview2.png";
import Menu from "../Menu/Menu";
import BlockLinkEnd from "../BlockLinkEnd/BlockLinkEnd";
import useShowRawInformation from "/src/features/editor/hook/useShowRawInformation";

const getLabel = (variable, child,data,index) => {
    if (variable && child.index == 1) {
        return "[" + variable.name.toUpperCase() + "]";
    }
    if (data.responses[index - 1]?.type == 'raw') {
        return useShowRawInformation('response', {}, '', 'Raw Response')
    }
    return child.text;
}

function BlockStatement({ name, x, y, children, data, object_id, lowVersion, type }) {

    // Need to sort block children juste in case
    if (children) {
        children.sort((a, b) => a.index - b.index)
    }


    // Propos block
    const block = {
        name, x, y, id: object_id, imageLow: imageStatementPreview, lowVersion, type, data, className: "propos", childrenBlocks: children
    }

    // Special case for old variable storage type
    var variable = null;
    if (data.responses.length && data.responses[0].type == 'custom') {
        variable = data.variable_redirect ? data.variable_redirect : data.responses[0].variable
        if (variable) {
            variable.name = variable.name.toLowerCase();
        }
    }

    let messageToShow = ''
    if (data.messages) {
        messageToShow = data.messages[0]?.type == 'raw' ? useShowRawInformation('statement', {}, '', 'Raw Message') : data.messages[0]?.content;
    }

    // lowVersion no information are action on the block, an image will be display if lowVersion
    // is_not_link  dans data.responses[x] par default = false
    // en attendant 
    /*
    for (let i = 0; i < data.responses.length; i++){
        if (data.responses[i].type =="raw"){
            data.responses[i].is_not_link = true;
        }
    }
    */
    return (
        <Block {...block}>
            {
                !lowVersion &&
                <>
                    <BlockLinkEnd parent_block_id={object_id} className="propos" style={{ left: "-15px", top: "60px", transform: "rotate(270deg)" }} />
                    <Menu className="propos" id={object_id} />
                    <div className="block_propos_icon"></div>
                    <div className="block_propos_title">{name}</div>
                    <div className="propos_innerblock start">{messageToShow}</div>
                </>
            }
            {children && children.map((child, index) => child.index != 0 &&
                <BlockChild key={child.object_id} parent_block_id={object_id} lowVersion={lowVersion} object_id={child.object_id}
                    className="propos" style={{ width: "200px", top: (80 + (index * 40)) + "px" }}
                    label={getLabel(variable, child,data,index)} is_not_link={data.responses[index - 1]?.is_not_link}/>
            )}
        </Block>
    )
}

export default BlockStatement;